export default {"src":"/_next/static/media/calendarOne_24.a91213d7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};